import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

import styles from '../../constants/styles';
import Flex from '../Flex';

// Local Typings
interface Props extends StyledFlexProps {
  disablePadding?: boolean;
  transition: number;
}
interface StyledFlexProps {
  bgColor: string;
}

// Local Variables
const StyledFlex = styled(Flex)<StyledFlexProps>(props => ({
  backgroundColor: props.bgColor,
}));

// Component Definition
const Overlay: FC<PropsWithChildren<Props>> = ({
  bgColor,
  disablePadding,
  transition,
  ...props
}) => (
  <StyledFlex
    bgColor={bgColor}
    bottom={0}
    className="dialog_overlay"
    justifyContent="center"
    left={0}
    overflowY="auto"
    padding={disablePadding ? 0 : 5}
    position="fixed"
    right={0}
    top={0}
    transition={`${transition}ms`}
    width="100vw"
    zIndex={styles.zIndex.modal}
    {...props}
  />
);

export default Overlay;
